import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import RadioGroup from '../RadioGroup';
import classnames from 'classnames';
import { Switch } from 'antd';

import style from './index.scss';
import { ActionItem, ActionLabel } from './styled';
import RangeDatePicker from '../RangeDatePicker';
import SortComponent from '../SortComponent';
import FilterComponent from '../FilterComponent';

const DEFAULT_STATE = {
  selectedDays: 30,
  selectedDateRange: [moment().subtract(30, 'days').add(1, 'days'), moment()],
  sortObject: null,
  selectedFilters: []
};

class WidgetActionComponent extends React.Component {
  state = {
    ...DEFAULT_STATE,
    selectedDateRange: this.props.dateRange
      ? [this.props.dateRange.startDate, this.props.dateRange.endDate]
      : DEFAULT_STATE.selectedDateRange
  };

  onDateRangeChange = (datesArray) => {
    const { sortObject, selectedFilters } = this.state;
    const { onChangeActions } = this.props;
    const from = datesArray[0];
    const to = datesArray[1];
    let q = {};

    q['sort'] = sortObject || {};
    q['filter'] = selectedFilters;

    if (onChangeActions) {
      onChangeActions({
        from,
        to,
        q: btoa(JSON.stringify(q))
      });
    }
  };

  onRadioGroupChange = (days) => {
    const { selectedDateRange } = this.state;
    const currentDate = moment(selectedDateRange[1]);
    const currentDateMinusDays = moment(currentDate)
      .subtract(days, 'days')
      .add(1, 'days');
    this.setState(
      {
        selectedDateRange: [currentDateMinusDays, currentDate],
        selectedDays: days
      },
      () => {
        this.onDateRangeChange([currentDateMinusDays, currentDate]);
      }
    );
  };

  onDatePickerChange = (dates) => {
    if (dates) {
      this.setState(
        {
          selectedDateRange: dates,
          selectedDays: null
        },
        () => {
          this.onDateRangeChange(dates);
        }
      );
    }
  };

  onSortChange = (sortObject) => {
    const { onChangeActions } = this.props;
    const { selectedDateRange, selectedFilters } = this.state;

    this.setState(
      {
        sortObject
      },
      () => {
        if (onChangeActions) {
          const from = selectedDateRange[0];
          const to = selectedDateRange[1];

          let q = {};
          q['sort'] = sortObject || {};

          q['filter'] = selectedFilters;

          onChangeActions({
            from,
            to,
            q: btoa(JSON.stringify(q))
          });
        }
      }
    );
  };

  onFilterChange = (filterItems) => {
    const { onChangeActions } = this.props;
    const { selectedDateRange, sortObject } = this.state;
    this.setState(
      {
        selectedFilters: filterItems
      },
      () => {
        if (onChangeActions) {
          const from = selectedDateRange[0];
          const to = selectedDateRange[1];

          let q = {};
          q['sort'] = sortObject || {};

          q['filter'] = filterItems;

          onChangeActions({
            from,
            to,
            q: btoa(JSON.stringify(q))
          });
        }
      }
    );
  };

  render() {
    const { selectedDateRange, selectedDays } = this.state;
    const {
      hasTriggeredOnlySwitch,
      hasDatePicker,
      hasDurationPicker,
      hasFilterPicker,
      hasSortPicker,
      sortItems,
      filterItems,
      disabledDate,
      size
    } = this.props;
    const durationItems = [
      { label: '7 Days', value: 7 },
      { label: '30 Days', value: 30 },
      { label: '90 Days', value: 90 },
      { label: '180 Days', value: 180 },
      { label: '360 Days', value: 360 }
    ];
    return (
      <div className={classnames(style.container)}>
        {hasTriggeredOnlySwitch && (
          <ActionItem>
            <ActionLabel>Triggered Only</ActionLabel>
            <Switch />
          </ActionItem>
        )}

        {hasDurationPicker ? (
          <div className={style.item}>
            <p className={style.actionLabel}>Duration</p>
            <RadioGroup
              items={durationItems}
              defaultValue={selectedDays}
              onChange={this.onRadioGroupChange}
              size={size ? size : 'large'}
            />
          </div>
        ) : null}

        {hasDatePicker ? (
          <div className={style.item}>
            <p className={style.actionLabel}>Date Range</p>
            <RangeDatePicker
              defaultDates={selectedDateRange}
              disabledDate={disabledDate}
              onChange={this.onDatePickerChange}
              size={size ? size : 'large'}
            />
          </div>
        ) : null}

        {hasSortPicker ? (
          <div className={style.item}>
            <p className={style.actionLabel}>Sort</p>
            <SortComponent
              columnGroups={sortItems}
              onChange={this.onSortChange}
            />
          </div>
        ) : null}

        {hasFilterPicker ? (
          <div className={style.item}>
            <p className={style.actionLabel}>Filter</p>
            <FilterComponent
              columnNames={filterItems}
              onFilterChange={this.onFilterChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

WidgetActionComponent.propTypes = {
  size: PropTypes.string,

  radioGroupItems: PropTypes.array,
  defaultDates: PropTypes.array,
  defaultDays: PropTypes.number,
  sortItems: PropTypes.array,
  filterItems: PropTypes.array,

  hasTriggeredOnlySwitch: PropTypes.bool,
  hasDurationPicker: PropTypes.bool,
  hasDatePicker: PropTypes.bool,
  hasSortPicker: PropTypes.bool,
  hasFilterPicker: PropTypes.bool,

  onChangeActions: PropTypes.func,
  disabledDate: PropTypes.func,
  dateRange: PropTypes.objectOf({
    startDate: PropTypes.string,
    endDate: PropTypes.string
  })
};

export default WidgetActionComponent;
